<template>
  <!-- temporary
  :value="drawer"
  stateless
   -->
  <v-navigation-drawer
    :mini-variant.sync="drawer"
    mini-variant-width="70"
    permanent
    app
    id="mainnav"
    class="secondary"
  >
    <v-list class="white--text my-3">
      <v-list-item class="justify-center">
        <v-img
          v-if="!drawer"
          style="max-width: 114.56px; max-height: 37px"
          src="/img/LG_logo_white.svg"
        />
        <v-img
          v-if="drawer"
          width="10"
          height="30"
          src="/img/livestock_logo.png"
        />
        <v-list-item-title
          v-if="drawer"
          class="text-h5 font-weight-bold white--text"
          >LG</v-list-item-title
        >
      </v-list-item>
    </v-list>

    <v-divider color="gray"></v-divider>
    <v-list
      nav
      dense
      v-for="(item, idx) in permissions"
      :key="idx"
      class="ml-5"
    >
      <!-- <v-list nav dense v-for="(item, idx) in menuItems" :key="idx" class="ml-5"> -->
      <v-list-item
        :exact="item.exact"
        active-class="primary"
        class=""
        v-if="!item.submenus"
        :to="getUrl(item)"
        link
        @click="open = false"
      >
        <v-list-item-icon>
          <v-icon v-if="item.icon" class="white--text font-weight-bold">{{
            item.icon
          }}</v-icon>
          <img v-else :src="item.src" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text font-weight-bold">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-else-if="item.submenus && !drawer"
        :value="open"
        no-action
        class="white--text"
      >
        <template #prependIcon>
          <v-icon class="white--text" v-if="item.icon">{{ item.icon }}</v-icon>
          <img style="margin-left: -2px" v-else :src="item.src" />
        </template>
        <template v-slot:activator>
          <v-list-item-content style="margin-left: -22px">
            <v-list-item-title class="white--text font-weight-bold">{{
              item.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template #appendIcon>
          <v-icon color="white">{{ "mdi-chevron-down" }}</v-icon>
        </template>

        <v-list-item
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
          active-class="sub-primary"
        >
          <v-list-item-icon>
            <v-icon class="white--text" v-if="subitem.icon">{{
              subitem.icon
            }}</v-icon>
            <img
              style="height: 10px; margin-top: 6px"
              class="submenu-image"
              v-else
              :src="subitem.src"
            />
          </v-list-item-icon>
          <v-list-item-title
            style="margin-left: -16px"
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>
        </v-list-item>

        <!-- <template v-if="!drawer">
        <v-list-item
        
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
          active-class="primary"
          
        >
          <v-list-item-icon>
            <v-icon class="white--text" v-if="subitem.icon">{{ subitem.icon }}</v-icon>
          <img style="height:10px; margin-top: 6px;" v-else :src="subitem.src" />
          </v-list-item-icon>
          <v-list-item-title
            style="margin-left: -16px"
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>
        </v-list-item>

      </template>

      <template v-if="drawer">
        <div class="white--text cloned-menu-item" >
        <v-list-item
        
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
          active-class="primary"
          class="white--text" 
        >
          <v-list-item-icon>
            <v-icon class="white--text" v-if="subitem.icon">{{ subitem.icon }}</v-icon>
          <img style="height:10px; margin-top: 6px;" v-else :src="subitem.src" />
          </v-list-item-icon>
          <v-list-item-title
            style="margin-left: -16px"
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>
        </v-list-item>
      </div>
        </template> -->
      </v-list-group>
      <v-list-group
        v-else-if="item.submenus && drawer"
        :value="open"
        no-action
        class="white--text helloooooooooooooooooooooooooo"
        v-bind:class="{ isDrawerMainMenu: isDrawerActive }"
      >
        <template #prependIcon>
          <v-icon class="white--text" v-if="item.icon">{{ item.icon }}</v-icon>
          <img style="margin-left: -2px" v-else :src="item.src" />
        </template>
        <template v-slot:activator>
          <v-list-item-content style="margin-left: -22px">
            <v-list-item-title class="white--text font-weight-bold">{{
              item.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template #appendIcon>
          <v-icon color="white">{{ "mdi-chevron-down" }}</v-icon>
        </template>

        <div
          v-bind:class="{ drawerSubMenu: isDrawerActive }"
          test="testsssssssssssssssssssssssss"
        >
          <v-list-item
            v-for="(subitem, i) in item.submenus"
            :key="i"
            :to="subitem.url"
            link
            active-class="primary"
          >
            <v-list-item-icon>
              <span class="green-dot"></span>
            </v-list-item-icon>

            <v-list-item-title
              style="margin-left: -16px"
              v-text="subitem.name"
              class="green--text"
            ></v-list-item-title>
          </v-list-item>
        </div>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div class="text-no-wrap text-caption text-center white--text mb-5">
        Version <br v-if="drawer" />
        1.0.0
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import isMobileMixin from "@/mixins/isMobileMixin";
export default {
  name: "sidebar",
  created() {},
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        return this.$store.commit("SET_DRAWER", !val);
      },
    },
    permissions() {
      return this.$store.getters.getUserPermissions(this.menuItems);
    },
    isDrawerActive() {
      return this.$store.state.drawer;
    },
  },
  methods: {
    setDrawer() {
      this.$store.commit("SET_DRAWER", !this.$store.state.drawer);
    },
    getUrl(item) {
      if (item.id === "my_farms") {
        if (this.$store.getters.getUser.userDetail.role === "farmer") {
          //code goes here
          return {
            name: "My farm",
            params: { farmId: this.$store.getters.getfarm.id || 1 },
          };
        }
      } else {
        return item.url;
      }
    },
  },
  watch: {
    "$store.state.drawer": function (value) {
      console.log(value, "value");
    },
    menuItems() {},
  },
  data() {
    return {
      open: false,
      userRole: null,
      menuItems: [
        // {
        //   id: "dashboard",
        //   icon: "mdi-view-grid-outline",
        //   name: this.$t("dashboard"),
        //   url: { name: "AdminDashboard" },
        //   exact: true,
        // },
        {
          id: "analytics",
          src: "/img/analystic.png",
          name: this.$t("Analytics"),
          url: { name: "Analytic" },
          exact: false,
        },
        {
          id: "users",
          src: "/img/users_sidebar_icon.svg",
          name: this.$t("users"),
          url: { name: "Users" },
          exact: false,
        },
        {
          id: "my_farms",
          src: "/img/Farm.png",
          name: this.$t("myFarm"),
          url: { name: "My farm", params: { farmId: 1 } },
          exact: false,
        },
        {
          id: "farms",
          src: "/img/Farm.png",
          name: this.$t("Farms"),
          url: { name: "FarmLists" },
          exact: false,
        },
        {
          id: "animals",
          src: "/img/animals.png",
          name: this.$t("animals"),
          url: { name: "Animals" },
          exact: false,
        },
        {
          id: "livestock_goals",
          src: "/img/livestock.png",
          name: this.$t("liveStockGoals"),
          url: { name: "LivestockGoals" },
          exact: false,
        },

        {
          id: "my_schedule",
          src: "/img/schedule.png",
          name: this.$t("mySchedule"),
          url: { name: "ActionList" },
          exact: false,
        },
        {
          id: "drug_inventory",
          icon: "mdi-pill",
          name: this.$t("drugInventory"),
          url: { name: "DrugList" },
          exact: false,
        },
        {
          id: "action_list",
          src: "/img/schedule.png",
          name: this.$t("My Schedule"),
          url: { name: "ActionList" },
          exact: false,
        },
        // {
        //   id: 12,
        //   icon: "mdi-pill",
        //   name: this.$t("drugInventory"),
        //   url: { name: "DrugList" },
        //   exact: false,
        // },
        //  {
        //   id: 12,
        //   icon: "mdi-pill",
        //   name: this.$t("Geofence"),
        //   url: { name: "Geofence" },
        //   exact: false,
        // },
        {
          id: "inventory",
          src: "/img/inventory.png",
          name: this.$t("Inventory"),
          url: { name: "Inventory" },
          exact: false,
          submenus: [
            {
              src: "/img/dot.png",
              name: this.$t("Equipment Inventory"),
              url: { name: "EquipmentInventory" },
            },
          ],
        },
        {
          id: "reports",
          src: "/img/reports.png",
          name: this.$t("Reports"),
          url: { name: "Analytics" },
          exact: false,
          submenus: [
            {
              src: "/img/dot.png",
              name: this.$t("Breeder Report"),
              url: { name: "AnalyticsBreeder" },
            },
            {
              src: "/img/dot.png",
              name: this.$t("Health Report"),
              url: { name: "AnalyticsHealth" },
            },
            // {
            //   icon: "mdi-file-chart",
            //   name:this.$t("Production Report") ,
            //   url: { name: "AnalyticsProduction" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name: this.$t("Data Scientist Report") ,
            //   url: { name: "AnalyticsDatasci" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name:this.$t("Product Report") ,
            //   url: { name: "AnalyticsProduct" },
            // },
            // {
            //   icon: "mdi-file-chart",
            //   name:this.$t("Semen/Embryo Report") ,
            //   url: { name: "AnalyticsSemenEmb" },
            // },
          ],
        },

        // {
        //   id: 10,
        //   src: "/img/ggg.png",
        //   name: this.$t("Genetics & Breeding"),
        //   url: { name: "Genetics" },
        //   exact: false,
        // },
        {
          id: "genetics_and_breeding",
          icon: "mdi-file-chart",
          name: this.$t("geneticsAndBreeding.geneticsAndBreeding"),
          exact: false,
          submenus: [
            {
              name: this.$t("animalSelection"),
              url: { name: "GeneticsList" },
              exact: false,
            },
            {
              name: this.$t("geneticsSearchTool"),
              url: { name: "GeneticSearch" },
              exact: false,
            },
            {
              name: this.$t("manageAnimalsGrouping"),
              url: { name: "ManageAnimalsGroup" },
            },
            {
              name: this.$t("Contemporary Group Setting"),
              url: { name: "contemporaryGroups" },
            },
            {
              name: this.$t("EPDModelSettings"),
              url: { name: "modelSettings" },
            },
            {
              name: this.$t("EPDRequiredFieldSettings"),
              url: { name: "requiredFieldsSetting" },
            },
            {
              icon: "mdi-file-chart",
              name: this.$t("Manage Bulk Uploads"),
              url: { name: "bulkUploadStatus" },
            },
            {
              // icon: "mdi-file-chart",
              name: this.$t("userGuide"),
              url: { name: "UserGuide" },
            },
            {
              icon: "mdi-file-chart",
              name: this.$t("CGReports"),
              url: { name: "cgReports" },
            },
          ],
        },

        {
          id: "pasture_management",
          src: "/img/Pasture.svg",
          name: this.$t("Pasture Management"),
          url: { name: "SatelliteReports" },
          exact: false,
        },

        // {
        //   id: 10,
        //   src: "/img/dairy.svg",
        //   name: this.$t("Dairy Management") ,
        //   url: { name: "DairyManagement" },
        //   exact: false,
        // },
        {
          id: "feed_management",
          src: "/img/ingredient-inventory.svg",
          name: this.$t("Feed Management"),
          submenus: [
            {
              src: "/img/dot.png",
              name: this.$t("Threshold Settings"),
              url: { name: "ThresholdSettings" },
            },
            {
              src: "/img/dot.png",
              name: this.$t("Ration Library"),
              url: { name: "RationLibrary" },
            },
            {
              src: "/img/dot.png",
              name: this.$t("Ingredient Inventory"),
              url: { name: "IngredientInventory" },
            },
            {
              src: "/img/dot.png",
              name: this.$t("Ingredient Library"),
              url: { name: "IngredientLibrary" },
            },
            {
              src: "/img/dot.png",
              name: this.$t("Suppliers"),
              url: { name: "FeedSuppliers" },
            },
          ],
        },
        // {
        //   id: 16,
        //   icon: "mdi-chart-areaspline",
        //   name: this.$t("inseminatorStatistics"),
        //   url: { name: "InseminatorList" },
        //   exact: false,
        // },
        // {
        //   id: 14,
        //   src: "/img/org_ntr_icon.svg",
        //   name: this.$t("organizationNTR"),
        //   url: { name: "ProductList" },
        //   exact: false,
        // },
        {
          id: "genotype_performance",
          icon: "mdi-file-chart",
          name: this.$t("genotypePerformance"),
          url: { name: "GenoList" },
          exact: false,
        },
        // {
        //   id: 15,
        //   icon: "mdi-chart-areaspline",
        //   name: this.$t("semenAutomation"),
        //   url: { name: "SemenAuto" },
        //   exact: false,
        // },
        // {
        //   id: 19,
        //   icon: "mdi-chart-areaspline",
        //   name: this.$t("activityLogs"),
        //   url: { name: "ActivityLog" },
        //   exact: false,
        // },
        // {
        //   id: 13,
        //   icon: "mdi-file-chart",
        //   name:this.$t("Analytics") ,
        //   url: { name: "Analytics" },
        //   exact: false,
        //   submenus: [
        //     {
        //       icon: "mdi-file-chart",
        //       name: this.$t("Feed Analytics"),
        //       url: { name: "calfAnalytics" },
        //     },
        //     {
        //       icon: "mdi-file-chart",
        //       name:this.$t("Production Analytics") ,
        //       url: { name: "calffAnalytics" },
        //     },
        //     {
        //       icon: "mdi-file-chart",
        //       name: this.$t("Health Analytics"),
        //       url: { name: "pregnancyAnalytics" },
        //     },
        // {
        //   icon: "mdi-file-chart",
        //   name:this.$t("Health Report") ,
        //   url: { name: "AnalyticsHealth" },
        // },
        // {
        //   icon: "mdi-file-chart",
        //   name:this.$t("Product Report") ,
        //   url: { name: "AnalyticsProduct" },
        // },
        // {
        //   icon: "mdi-file-chart",
        //   name:this.$t("Semen/Embryo Report") ,
        //   url: { name: "AnalyticsSemenEmb" },
        // },
        // {
        //   icon: "mdi-file-chart",
        //   name:this.$t("Farms") ,
        //   url: { name: "AnalyticsProduction" },
        // },
        //   ],
        // },
      ],
    };
  },
  async mounted() {
    const farmMenuIndex = this.menuItems.findIndex(
      menu => menu.id == "my_farms"
    );
    this.userRole = this.$store.getters.getUser.userDetail.role;
    if (this.userRole === "farmer") {
      const farmId = this.$store.getters.getfarm.id;
      this.menuItems[farmMenuIndex].url = {
        name: "My Farm",
        params: { farmId },
      };
    }
    if (this.userRole !== "admin") {
      for (let i = 0; i < this.menuItems.length; i++) {
        if (this.menuItems[i].id === "feed_management") {
          this.menuItems[i].submenus = this.menuItems[i].submenus.filter(
            submenu => submenu.name !== "Threshold Settings"
          );
        }
      }
    }
  },
  mixins: [isMobileMixin],
};
</script>

<style>
.isDrawerMainMenu {
  position: relative;
}

.drawerSubMenu {
  position: absolute;
  top: 0px;
  border-radius: 8px;
  left: 55px;
  z-index: 100000;
  width: 196px;
  background: white;
}
</style>

<style v-if="isDrawerActive">
/* .v-navigation-drawer--mini-variant {
  overflow: visible !important;
}

.v-navigation-drawer {
  overflow: visible !important;
}

.v-navigation-drawer__content {
  overflow-y: visible !important;
  overflow-x: visible !important;
}

.v-list-group--active .v-list-group__items,
.v-navigation-drawer--mini-variant .v-list-group--sub-group {
  display: block !important;
}

.v-navigation-drawer--mini-variant .v-list-item > *:not(:first-child) {
  position: inherit !important;
  height: auto !important;
} */

.green-dot {
  height: 10px;
  width: 10px;
  background-color: #00bd73;
  border-radius: 50%;
  margin-top: 6px;
}

.green--text {
  color: #00bd73;
}

/* .v-navigation-drawer--mini-variant .v-list-item > *:first-child.v-image {
  width: 40px !important;
} */

.v-list-group__items .v-list-item__icon {
  padding-right: 15px;
}
.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  display: block;
}
.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon img {
  max-width: 24px;
}
</style>

<!-- <style>


element.style {
    position: relative;
}

element.style {
    position: absolute;
    top: 0px;
    border-radius: 8px;
    left: 245px;
    z-index: 100000;

        width: 196px;


    background: red;}


.v-navigation-drawer {

    overflow: visible;
   
}

.v-navigation-drawer__content {
    height: 100%;
    /* overflow-y: visible; */
    /* overflow-x: visible; */
}
.v-navigation-drawer--mini-variant {
    /* overflow: hidden; */
}


.v-navigation-drawer--mini-variant .v-list-group--no-action .v-list-group__items, .v-navigation-drawer--mini-variant .v-list-group--sub-group {
    /* display: none; */
}

.v-navigation-drawer--mini-variant .v-list-item > *:not(:first-child) {
    /* position: absolute !important; */
    /* height: 1px; */
    /* width: 35px; */
    /* overflow: hidden; */
    /* clip: rect(1px, 1px, 1px, 1px); */
    /* white-space: nowrap; */
    display: initial;}

//    height: 10px;
    width: 10px;
    background-color: #00BD73;
    border-radius: 50%;
    /* display: inline-block; */
    margin-top: 6px;
    /* padding: 50px 0; */
    text-align: ce`;
    positionpx: 0px 0px -25px;
    /* top: 50%; */
    /* left: 50%; */
    /* margin: -25px 0 0 -25px;...
</style> -->

<style scoped>
::v-deep .v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 64px;
  margin-left: -50px;
}
</style>

<style scoped lang="scss">
.theme--light.v-list-item--active::before {
  opacity: 0 !important;
}

.submenu-image {
  display: none;
}
.sub-primary {
  .white--text {
    font-weight: bold;
  }

  .submenu-image {
    display: block;
  }
}
</style>
